<template>
  <div class="tabss" :style="`display:${nonecode}`">
    <div class="box">
      <div class="header">
        <div>预警告警记录</div>
        <CloseIcon size='24px' @click="resetForm()" />
      </div>
      <div class="bodybox">
        <div class="head">
          <bluetabs
            :tabList="tablist"
            @tabchange="tabchange"
            style="width: 28%;height: 6%; background: rgba(26,50,83,0.9);"
          />
<!--          <el-button class="allread" @click="allread">全部已读</el-button>-->
        </div>

        <el-table
          :data="tableDatas"
          style="width: 100%;overflow: hidden;"
          class="table"
          cell-class-name="table-cell-center"
          max-height="600"
        >
          <el-table-column   type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="isRead" label="处理状态" width="120">
            <template slot-scope="scope">
              <div
                :class=" scope.row.isHandling ==='已处理'?'handled':'unhandled'"

              >
<!--              "-->
             {{ scope.row.isHandling }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="所属项目"></el-table-column>
          <el-table-column prop="deviceNumber" label="设备编号" ></el-table-column>
          <el-table-column prop="alarmType" label="警告类型" width="80">
            <template slot-scope="scope">
              <span
                :style="`color:#${scope.row.alarmType=='预警'?'FFFFFF':'E43E3E'}`"
              >{{ scope.row.alarmType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="alarmCode" label="警告码" width="80"></el-table-column>
          <el-table-column prop="threshold" label="阀值" width="80"></el-table-column>
          <el-table-column prop="realTimeValue" label="实时值" width="80">
            <template slot-scope="scope">
              <span
                :style="`color:#${scope.row.threshold < scope.row.realTimeValue?'FFFFFF':'E43E3E'}`"
              >{{ scope.row.realTimeValue }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="alarmDescription" label="警告指标" align="center"></el-table-column>
<!--          <el-table-column fixed="right" label="操作" width="100">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button-->
<!--                style="width: 3.75rem;height: 2rem;background:#1074DB;color:#fff;line-height: 0.7rem;"-->
<!--                type="text"-->
<!--                size="small"-->
<!--                @click="handleClick(scope.row)"-->
<!--              >{{ scope.row.isRead }}</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <template slot="empty">
            <img style="margin-top: 10rem;" src="../../assets/image/暂无数据@2x.png" alt />
            <p>暂无预警数据</p>
          </template>
        </el-table>
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="pagination.current"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pagination.pageSize"
          layout="total, ->,sizes, prev, pager, next, jumper"
          :total="pagination.total"
          class="pagination"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

  <script>
import { CloseIcon } from "tdesign-icons-vue";
export default {
  components: {
    CloseIcon
  },
  props: {
    nonecode: {
      default: ""
    }
  },
  data() {
    return {
      nonecode1: this.nonecode,
      columns: [
        { colKey: "applicant", title: "申请人", width: "100" },
        {
          colKey: "status",
          title: "申请状态",
          width: "150"
        },
        { colKey: "channel", title: "签署方式" },
        { colKey: "detail.email", title: "邮箱地址", ellipsis: true },
        { colKey: "createTime", title: "申请时间" }
      ],
      tablist: [
        { label: "今日", value: 1 },
        { label: "三日", value: 2 },
        { label: "七日", value: 3 },
        { label: "查看更多", value: 4 }
      ],
      tvalue: "",
      tableheaders: [
        { title: "序号", colKey: "id" },
        { title: "已读状态", colKey: "deviceType" },
        { title: "所属项目", colKey: "projectName" },
        { title: "设备编号", colKey: "deviceModel" },
        { title: "警告类型", colKey: "installationTime" },
        { title: "警告码", colKey: "operatingDuration" },
        { title: "阈值", colKey: "supplier" },
        { title: "实时值", colKey: "brand" },
        { title: "警告指标", colKey: "deviceStatus" },
        // {
        //   colKey: "operation",
        //   title: "操作",
        //   fixed: "right",
        //   width: 150
        // }
      ],
      tableDatas: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showJumper: true
      },
      params: {
        alarmType: "",
        attribute: "",
        number: "",
        startTime: "",
        endTime: ""
      },
      currentTime: null,
      endTime: null
    };
  },
  mounted() {
    this.params.startTime = this.getDate(0).startformattedTime;
    this.params.endTime = this.getDate(0).endformattedTime;
    this.getaAlarmAllList(this.params);
  },
  methods: {
    // 获取序号
    indexMethod(index) {
      return index;
    },
    onSelectChange(selectedRowKeys, context) {},
    // 分页变化时触发该事件
    onPageChange(pageInfo, newData) {
      if (!this.pagination.defaultCurrent) {
        // 受控用法所需，即使用 pagination.current 和 pagination.pageSize 时，必须保留恢复下面 2 行代码
        this.pagination.current = pageInfo.current;
        this.pagination.pageSize = pageInfo.pageSize;
      }
    },
    onChange(params, context) {},
    handleClick(val) {
      if (val.isRead == "未读") {
        this.getAlarmRead(val);
      }
    },
    // 分页
    currentChange(e){
      this.pagination.current = e
      this.getaAlarmAllList(this.params)
    },
    // 分页
    sizeChange(e) {
      this.pagination.pageSize = e
      this.getaAlarmAllList(this.params)
    },
    // 获取时间
    getDate(date) {
      let vueTime = new Date();
      let year = vueTime.getFullYear();
      let month = ("0" + (vueTime.getMonth() + 1)).slice(-2);
      let day = ("0" + vueTime.getDate()).slice(-2);
      let formattedTime = `${year}-${month}-${day} 00:00:00`;
      let formattedTime1 = `${year}-${month}-${day} 23:59:59`;
      //获取当前时间的前七天
      let nowTime = vueTime.getTime();
      let oneDay = 24 * 60 * 60 * 1000;
      let sevenLastTime = nowTime - date * oneDay;
      let sevenLastDate = new Date(sevenLastTime);
      let year2 = sevenLastDate.getFullYear();
      let month2 = ("0" + (sevenLastDate.getMonth() + 1)).slice(-2);
      let day2 = ("0" + sevenLastDate.getDate()).slice(-2);
      let endformattedTime = `${year2}-${month2}-${day2} 00:00:00`;
      let newDate = {
        startformattedTime: formattedTime1,
        endformattedTime: endformattedTime
      };
      return newDate;
    },
    tabchange(e) {
      this.tvalue = this.tablist[e.value - 1].label;
      console.log(e.value);
      this.params.startTime = "";
      this.params.endTime = "";
      if (e.value == 1) {
        // 当天
        this.params.startTime = this.getDate(0).startformattedTime;
        this.params.endTime = this.getDate(0).endformattedTime;
        this.getaAlarmAllList(this.params);
      } else if (e.value == 2) {
        // 前三天
        this.params.startTime = this.getDate(3).startformattedTime;
        this.params.endTime = this.getDate(3).endformattedTime;
        this.getaAlarmAllList(this.params);
      } else if (e.value == 3) {
        // 前七天
        this.params.startTime = this.getDate(7).startformattedTime;
        this.params.endTime = this.getDate(7).endformattedTime;
        this.getaAlarmAllList(this.params);
      } else {
        // 所有
        this.params.startTime = "";
        this.params.endTime = "";
        this.getaAlarmAllList(this.params);
      }
    },
    resetForm() {
      if (this.nonecode1 == "block") {
        this.nonecode1 = "none";
      } else {
        this.nonecode1 = "block";
      }
      this.$emit("noneChange", this.nonecode1);
    },
    // 全部已读
    allread() {
      console.log(this.tableDatas);
      let newArr = [];
      this.tableDatas.map(item => {
        newArr.push(item.id);
      });
      this.getAlarmRead(newArr);
    },
    // 获取预警数据
    async getaAlarmAllList(data) {
      let page = {
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current
      };
      let res = await this.$https.post(
        this.$url.realname.warning.alarmAll,
        data,
        page
      );
      this.pagination.total = res.total;
      this.tableDatas = res.rows;
      this.pagination.total = res.total;
      console.log(this.tableDatas, "获取数据");
    },
    async getAlarmRead(val) {
      let data;
      if (Array.isArray(val)) {
        data = {
          idList: val
        };
      } else {
        data = {
          idList: [val.id]
        };
      }
      let res = await this.$https.post(
        this.$url.realname.warning.alarmRead,
        data
      );
      if (res.code === 200) {
        this.getaAlarmAllList(this.params);
      }
    }
  }
};
</script>

  <style lang="scss" scoped>
  .handled{
    height: 24px;
    width: 70px;
    padding: 2px 15px;
    background: rgba(16,116,219,0.08);
    border-radius: 12px;
    border: 1px solid #1074DB;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #3595E8;
    line-height: 20px;
    text-align: center;
    font-style: normal;
  }
  .unhandled{
    height: 24px;
    width: 70px;
    padding: 2px 15px;
    background: rgba(239,118,38,0.1);
    border-radius: 12px;
    border: 1px solid rgba(239,118,38,0.9);
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(239,118,38,0.9);
    line-height: 20px;
    text-align: center;
    font-style: normal;
  }
::-webkit-scrollbar {
  // display: none;
}

.el-pagination{
  margin-top: 24px;
}
::v-deep .el-pagination .btn-next {
  background: #172e4c;
  color: #fff;
}
::v-deep .el-pagination .btn-prev {
  background: #172e4c;
  color: #fff;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  background: #172e4c;
  border: 1px #5e5e5e solid;
  color: #fff;
}
::v-deep .el-pager li.active {
  background: #1074db;
  color: #fff;
  border-radius: 0.25rem;
}
::v-deep .el-pager li {
  background: #172e4c;
  color: #fff;
}
::v-deep .el-pagination button:disabled {
  background: #172e4c;
}
::v-deep .el-pagination .el-select .el-input .el-input__inner {
  background: #172e4c;
  border: 1px #5e5e5e solid;
}
.allread {
  background-color: #1074db !important;
}
::v-deep .el-table::before {
  content: none;

}
::v-deep .el-table__fixed-right::before {
  content: none;
}
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: none;
}
::v-deep .el-table {
  .gutter{
    display: none;
  }
}

::v-deep .table {
  margin-top: 1.5rem;
  border-radius: 4px;
  height: 42rem;
  background: #172e4c;
  overflow-y: auto;
}
::v-deep .is-leaf {
  background: #1e3e62 !important;
}
::v-deep .el-table__row {
  background: #172e4c;
  color: #fff;
  > td {
    border-bottom: 1px #3c3d3e solid !important;
  }
}
::v-deep .el-table tbody tr:hover > td,
::v-deep .el-table__body tr.hover-row > td.el-table__cell {
  background: #172e4c !important;
}
.tabss {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99;
  background: rgba(0, 0, 0, 0.8);
  padding: 3% 7% 0% 17%;
  .box {
    width: 80%;
    height: 90%;
    margin: 0 auto;
    background: rgba(26, 50, 83, 0.9);
    overflow: auto;
    .header {
      width: 100%;
      height: 8%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1.5rem;
      font-size: 18px;
      background: #1e3e62;
      > div {
        font-size: 16px;
      }
    }
    .bodybox {
      width: 100%;
      height: 92%;
      padding: 25px;
      .head {
        display: flex;
        justify-content: space-between;
        button {
          height: 1.75rem;
          line-height: 1.75rem;
          padding: 0 1rem;
          background: #172e4c;
          color: #fff;
          border: none;
          border-radius: 4px;
          outline: none;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep .t-pagination {
  color: #fff;
}
::v-deep .t-pagination__jump {
  background: #1a304e;
}
::v-deep .t-input__inner {
  background: #1a304e;
  color: #fff;
}

::v-deep .t-input {
  background: #1a304e;
}
::v-deep .t-pagination .t-input-adornment__append {
  // height: 3.375rem;
  border: 1px solid #fff;
}
::v-deep .t-input-adornment__text {
  color: #fff;
}
::v-deep .t-input.t-is-readonly {
  background: #1a304e;
}
::v-deep .t-select .t-fake-arrow {
  color: #fff;
}
::v-deep .t-table .t-icon {
  color: #fff;
}
</style>
